import React from 'react';
import { Route } from 'react-router-dom';
import { Provider } from 'react-redux';
import { store } from './store/store';
import './App.css';
import 'antd/dist/antd.css';
import TrajectoryApp from './apps/TrajectoryApp';
import CfdApp from './apps/CfdApp';

// const store = store(); //Calling Redux Store

// var pendingRequests = 0;

function App() {
  // console.log("App")
  return (
    <Provider store={store}>
      <Route exact={true} path={[
        '/',
        '/:heatmapId',
      ]} children={<TrajectoryApp/>}/>
      <Route exact={true} path={[
        '/cfd/:routeId/:dateRangeId',
        '/cfd/:routeId/',
      ]} children={<CfdApp/>}/>
    </Provider>
  );
}

export default App;

